import { Directive, Input, Renderer2, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[buttonType]'
})
export class AegButtonTypeDirective implements OnInit {
  @Input('buttonType') buttonType: string;

  constructor(public renderer: Renderer2, public elem: ElementRef) {
  }

  ngOnInit() {
    this.setButtonType(this.buttonType);
  }

  public setButtonType(type: string) {
    switch (type) {
      case 'white': {
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_default');
        this.renderer.addClass(this.elem.nativeElement.children[0],'mg-ui-button_white');
        break;
      }

      case 'outline': {
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_default');
        this.renderer.addClass(this.elem.nativeElement.children[0],'mg-ui-button_outline');
        break;
      }

      case 'clear-blue': {
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_default');
        this.renderer.addClass(this.elem.nativeElement.children[0],'mg-ui-button_clear-blue');
        break;
      }

      case 'clear-white': {
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_default');
        this.renderer.addClass(this.elem.nativeElement.children[0],'mg-ui-button_clear-white');
        break;
      }
      
      case 'disabled': {
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_default');
        this.renderer.removeClass(this.elem.nativeElement.children[0], 'mg-ui-button_transition-inside');
        this.renderer.addClass(this.elem.nativeElement.children[0],'mg-ui-button_disabled');
        break;
      }
    }
  }

}